import React, { useEffect, useRef } from 'react';
import './Historia.css';
import img2017 from '../../assets/historia/historia-2017.jpg';
import img2018 from '../../assets/historia/historia-2018.jpg';
import img2021 from '../../assets/historia/historia-2021.jpg';
import img2023 from '../../assets/historia/historia-2023.png';
import img2024 from '../../assets/historia/historia-2024.png';
import img2025 from '../../assets/historia/historia-2025.png';

const timelineEvents = [
  {
    year: '2017',
    title: 'Nace MG Profesionales',
    description:
      'Se funda MG Profesionales con la visión de brindar servicios integrales de coaching y acompañamiento deportivo, poniendo la psicología al servicio del rendimiento',
      image: img2017,
      side: 'left',
  },
  {
    year: '2018',
    title: 'Equipo Consolidado',
    description:
      'Se conforma el equipo ligado al acompañamiento y al coaching deportivo, fortaleciendo nuestra capacidad de atención y ampliando el alcance del programa',
          image: img2018,
      side: 'right',
  },
  {
    year: '2021',
    title: 'Implementación del Reconocimiento Emocional',
    description:
      'Se incorpora de forma estructurada la metodología de reconocimiento emocional al programa, consolidando la conexión entre estado mental y rendimiento deportivo',
    image: img2021,
    side: 'left',
  },
  {
    year: '2023',
    title: 'Retorno al Fútbol Profesional',
    description:
      'MG Profesionales retoma su presencia en el fútbol profesional, brindando charlas y sesiones de psicología deportiva a jugadores en formación y sus cuerpos técnicos',
    image: img2023,
    side: 'right',
  },
  {
    year: '2024',
    title: 'Consolidación del Equipo',
    description:
      'El equipo de MG Profesionales se consolida con un grupo de psicólogos deportivos comprometidos, listos para acompañar a deportistas en todas las etapas de su desarrollo',
    image: img2024,  
    side: 'left',
  },
  {
    year: '2025',
    title: 'Psicólogo deportivo de la Selección Chilena',
    description:
      'MG Profesionales es oficializado como área de psicología deportiva de la Selección Chilena, marcando un hito en nuestra trayectoria y en el desarrollo de la disciplina en Chile',
    image: img2025,
    side: 'right',
  },
];

const Historia = () => {
  const itemsRef = useRef([]);

  useEffect(() => {
    const observer = new IntersectionObserver(
      (entries) => {
        entries.forEach((entry) => {
          if (entry.isIntersecting) entry.target.classList.add('visible');
        });
      },
      { threshold: 0.12 }
    );
    itemsRef.current.forEach((el) => el && observer.observe(el));
    return () => observer.disconnect();
  }, []);

  return (
    <div className="historia-page">

      {/* ── HEADER ── */}
      <header className="historia-header">
        <div className="historia-header__inner">
          <h1 className="historia-header__title">Nuestra Historia</h1>
          <p className="historia-header__subtitle">
            Un recorrido por los momentos que nos han definido
          </p>
        </div>
        <div className="historia-header__bar" />
      </header>

      {/* ── TIMELINE ── */}
      <section className="historia-timeline">
        <div className="historia-timeline__track" />

        {timelineEvents.map((event, i) => (
          <article
            key={i}
            ref={(el) => (itemsRef.current[i] = el)}
            className={`ht-item ht-item--${event.side}`}
          >
            {event.side === 'left' ? (
              <>
                <div className="ht-item__content">
                  <span className="ht-item__year">{event.year}</span>
                  <h3 className="ht-item__title">{event.title}</h3>
                  <p className="ht-item__desc">{event.description}</p>
                </div>
                <div className="ht-item__dot"><div className="ht-item__dot-inner" /></div>
                <div className="ht-item__media">
                  {event.image
                    ? <div className="ht-item__img-wrapper">
                        <img src={event.image} alt={`${event.year} - ${event.title}`} />
                        <div className="ht-item__img-year">{event.year}</div>
                      </div>
                    : <div className="ht-item__spacer" />}
                </div>
              </>
            ) : (
              <>
                <div className="ht-item__media">
                  {event.image
                    ? <div className="ht-item__img-wrapper">
                        <img src={event.image} alt={`${event.year} - ${event.title}`} />
                        <div className="ht-item__img-year">{event.year}</div>
                      </div>
                    : <div className="ht-item__spacer" />}
                </div>
                <div className="ht-item__dot"><div className="ht-item__dot-inner" /></div>
                <div className="ht-item__content">
                  <span className="ht-item__year">{event.year}</span>
                  <h3 className="ht-item__title">{event.title}</h3>
                  <p className="ht-item__desc">{event.description}</p>
                </div>
              </>
            )}
          </article>
        ))}
      </section>

      {/* ── MISIÓN / VISIÓN ── */}
      <section className="historia-mv">
        <div className="historia-mv__card">
          <div className="historia-mv__accent" />
          <h2 className="historia-mv__heading">Misión</h2>
          <p className="historia-mv__text">
            Acompañar a deportistas amateur y de alto rendimiento, clubes, equipos y organizaciones en cada etapa de su proceso, entregando herramientas psicológicas concretas que potencien el rendimiento, el bienestar emocional y el desarrollo integral del ser humano detrás del atleta. Creemos que la fortaleza mental no es un complemento, sino el pilar que sostiene cada logro deportivo.
          </p>
        </div>
        <div className="historia-mv__card">
          <div className="historia-mv__accent" />
          <h2 className="historia-mv__heading">Visión</h2>
          <p className="historia-mv__text">
            Consolidarnos como el programa de psicología deportiva más influyente de Chile y Latinoamérica, siendo reconocidos por transformar la manera en que deportistas, clubes y organizaciones entienden el desarrollo mental. Aspiramos a construir una cultura donde trabajar la mente sea tan natural e indispensable como entrenar el cuerpo, impactando a cada deportista en su dedicación y excelencia.
          </p>
        </div>
      </section>

    </div>
  );
};

export default Historia;